import template from './deadline.jade';
import deadlineQuarter from './../../../enums/deadline-quarter';
import validation from './../../../services/validation';

export default angular.module('cian.addForm.deadline', []).directive('cianAfAboutBuildingDeadline', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    '$scope',
    'deviceService',
    function ($scope, deviceService) {
      this.isMobile = deviceService.isMobile;
      if (!this.ad.building) {
        this.ad.building = {};
      }

      if (!this.ad.building.deadline) {
        this.ad.building.deadline = {
          year: null,
          quarter: null,
        };
      }

      const currentYear = new Date().getFullYear();
      this.years = [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => {
        const year = currentYear + num;

        return { value: year, text: year };
      });
      this.deadlineQuarters = deadlineQuarter;

      this.deadlineYearValidation = validation(this.form, 'deadlineYear', {
        required: 'Выберите значение',
      });

      this.deadlineQuarterValidation = validation(this.form, 'deadlineQuarter', {
        required: 'Выберите значение',
      });

      const getDateFromPeriod = period => {
        const year = period.year;
        const quarter = deadlineQuarter.find(item => item.key === period.quarter);
        const month = quarter ? quarter.startMonth : undefined;

        return year && !isNaN(month) ? new Date(year, month) : undefined;
      };

      const currentDate = new Date();
      currentDate.setMonth(currentDate.getMonth() - 9); // 3 месяца в квартале * 3 квартала назад = -9 месяцев

      // Если текущая дата не более чем на три квартала больше даты сдачи, выставить чекбокс Сдан
      if (!this.ad.id) {
        // Если не редактирование объявления
        $scope.$watchCollection(
          () => ({
            year: this.ad.building.deadline ? this.ad.building.deadline.year : null,
            quarter: this.ad.building.deadline ? this.ad.building.deadline.quarter : null,
          }),
          period => {
            const periodDate = getDateFromPeriod(period);

            if (!this.form.deadlineIsComplete.$touched) {
              this.ad.building.deadline.isComplete = currentDate > periodDate;
            }
          },
        );
      }
    },
  ],
  controllerAs: 'deadline',
  template,
})).name;
